import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';

lazySizes.cfg.preloadAfterLoad = true;
